export const bordersSubTitle = [
    {
        text: "Use border utilities to add or remove an element's borders.",
    }
]

export const borderStyleSubTitle = [
    {
        text: "Use of any component to give the different styles of border using",
        code: ' border-*radius/border-color/border-width '
    },
    {
        text: 'class.'
    }
];

export const backgroundColorSubTitle = [
    {
        text: 'Using any component to add background color using ',
        code: '.bg-* '
    },
    {
        text: '& ',
        code: '.alert-light-*'
    },
    {
        text: ' class.'
    }
];

export const borderColorSubTitle = [
    {
        text: "Use the ",
        code: '.b-*/.b-t-*/.b-b-*/.b-l-*/.b-r-*'
    },
    {
        text: ' class for borders.'
    }
];

export const imageSubTitle = [
    {
        text: "Set different type of height & width using ",
        code: '.img-*'
    },
    {
        text: " & ",
        code: '.img-h-*'
    },
    {
        text: ' class.'
    }
];

export const fontStyleSubTitle = [
    {
        text: "To set different font-style use ",
        code: ' .f-s-* [normal/italic/oblique/initial/inherit]'
    },
    {
        text: 'class.'
    }
];

export const fontWeightSubTitle = [
    {
        text: "Using",
        code: ' .f-w-*[100/300/400/600/700/900] '
    },
    {
        text: 'class set different font-weight.'
    }
];

export const textColorSubTitle = [
    {
        text: "Give the text color using ",
        code: '.font-*'
    },
    {
        text: " class.",
    }
];

export const fontSizeSubTitle = [
    {
        text: "Use",
        code: ' .f-*[14/16/18..etc] '
    },
    {
        text: 'class to add font-sizes.'
    }
];

export const additiveBorderData = ['border', 'border-top', 'border-bottom', 'border-end'];
export const subtractiveData = ['0', 'top-0', 'end-0', 'bottom-0', 'start-0'];
export const additiveRadiusData = ['rounded', 'rounded-top', 'rounded-end', 'rounded-bottom', 'rounded-start', 'rounded-pill', 'rounded-circle'];
export const customBorderData = [0, 1, 2, 3, 4, 5];
export const borderColorData = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light'];
export const borderSideColorData = ['primary', 't-primary', 'b-primary', 'l-primary', 'r-primary', 'secondary', 't-secondary', 'b-secondary', 'l-secondary', 'r-secondary', 'success', 't-success', 'b-success', 'l-success', 'r-success', 'danger', 't-danger', 'b-danger', 'l-danger', 'r-danger', 'warning', 't-warning', 'b-warning', 'l-warning', 'r-warning', 'info', 't-info', 'b-info', 'l-info', 'r-info', 'dark', 't-dark', 'b-dark', 'l-dark', 'r-dark', 'light', 't-light', 'b-light', 'l-light', 'r-light'];
export const imageData = [50, 60, 70, 90, 100];
export const fontSizeData = [6, 5, 4, 3, 2, 1];

export const fontStyleData = [
    {
        id: 1,
        text: 'normal',
        class: 'fw-normal'
    },
    {
        id: 2,
        text: 'italic',
        class: 'fst-italic'
    },
    {
        id: 3,
        text: 'oblique',
        class: 'f-s-oblique'
    },
    {
        id: 4,
        text: 'inherit',
        class: 'f-s-inherit'
    }
];

export const fontWeightData = [
    {
        id: 1,
        class: 100,
        text: 'light'
    },
    {
        id: 2,
        class: 300,
        text: 'light'
    },
    {
        id: 3,
        class: 400,
        text: 'light'
    },
    {
        id: 4,
        class: 600,
        text: 'bolder'
    },
    {
        id: 5,
        class: 700,
        text: 'bold'
    },
    {
        id: 6,
        class: 900,
        text: 'bold'
    }
]